import { Injectable } from '@angular/core';
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  protected appComponent: AppComponent;

  constructor() { }

  showError(title: string, text: string) {
    return this.appComponent.showError(title, text);
  }

  showSuccess(title: string, text: string) {
    this.appComponent.showSuccess(title, text);
  }

  showInfo(title: string, text: string) {
    this.appComponent.showInfo(title, text);
  }

  showLoading(title: string, text: string) {
    this.appComponent.showLoading(title, text);
  }

  hideLoading() {
    this.appComponent.hideLoading();
  }

  setComponent(component: AppComponent) {
    this.appComponent = component;
  }
}
